






















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SudokuPossibilities extends Vue {
  @Prop() private possibilities!: number[];
  @Prop() private noClick!: boolean;

  onClick (val: number) {
    if (this.noClick) {
      return
    }
    const index = this.possibilities.indexOf(val)
    this.possibilities.splice(0, index)
    this.possibilities.splice(1, this.possibilities.length)
  }

  onRightClick (evt: Event, val: number) {
    evt.preventDefault()
    if (this.noClick) {
      return
    }
    const index = this.possibilities.indexOf(val)
    this.possibilities.splice(index, 1)
  }
}

